export function formatPhoneNumber(phoneNumber: string) {
  if (!phoneNumber) {
    return "";
  }

  // Remove all non-digit characters
  const cleanedNumber = phoneNumber.replace(/\D/g, "");

  if (!cleanedNumber) {
    return "";
  }

  // Handle US numbers (10 digits or 11 digits starting with 1)
  if (cleanedNumber.length === 10) {
    // 10-digit US number (without country code)
    return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
  } else if (cleanedNumber.length === 11 && cleanedNumber.startsWith("1")) {
    // 11-digit US number (with country code 1)
    return `(${cleanedNumber.slice(1, 4)}) ${cleanedNumber.slice(4, 7)}-${cleanedNumber.slice(7)}`;
  } else if (phoneNumber.startsWith("+1") && cleanedNumber.length === 11) {
    // E.164 format US number (+1XXXXXXXXXX)
    return `(${cleanedNumber.slice(1, 4)}) ${cleanedNumber.slice(4, 7)}-${cleanedNumber.slice(7)}`;
  } else {
    // For international numbers or non-standard formats, return as-is with minimal formatting
    if (phoneNumber.startsWith("+")) {
      return phoneNumber;
    } else {
      return `+${cleanedNumber}`;
    }
  }
}

// Format for API calls (ensure E.164 format like +1XXXXXXXXXX)
export function formatPhoneNumberForAPI(number: string): string {
  if (!number) return "";
  const cleanedNumber = number.replace(/\D/g, "");

  if (!cleanedNumber) return "";

  // Add +1 for potential 10-digit North American numbers
  if (cleanedNumber.length === 10 && !cleanedNumber.startsWith("1")) {
    return `+1${cleanedNumber}`;
  }

  // Ensure '+' prefix if missing
  if (!cleanedNumber.startsWith("+")) {
    return `+${cleanedNumber}`;
  }

  return cleanedNumber;
}
